import React from 'react';
import { bitsCards } from './data';
import './Styles/What.scss';
import Card from '../../Shared/Cards/HubCard/Card';
const Bits=()=>{
    return(
        <div className="what-hub">
            <h1>Bits & Bobs</h1>
            <p>A collection of online guides and downloadable assets, eBooks and customer stories for you to carry with you</p>
            <div className="cards">
                {bitsCards.map((d) =>{
                    return(
                        <Card {...d}/>
                    )
                })}
            </div>
        </div>
    )
};
export default Bits;